/**
 * ConnectTikTokButton
 * OAuth TikTok initialization button
 */

import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Loader2 } from 'lucide-react';
import { fetchWithAuth } from '../../utils/api';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// TikTok SVG Icon
const TikTokIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

export default function ConnectTikTokButton({ variant = 'default', className = '' }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleConnect = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetchWithAuth(
        '/api/auth/tiktok/start',
        {
          method: 'POST',
          body: JSON.stringify({})
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to start OAuth');
      }

      const data = await response.json();

      if (data.success) {
        const { authorization_url, state } = data.data;
        
        // Store state for callback validation
        sessionStorage.setItem('tiktok_oauth_state', state);
        
        // Redirect to TikTok
        window.location.href = authorization_url;
      } else {
        setError(data.message || 'Failed to start OAuth');
        setLoading(false);
      }
    } catch (err) {
      console.error('Connect TikTok error:', err);
      setError(err.message || 'Failed to connect');
      setLoading(false);
    }
  };

  return (
    <div className="space-y-2">
      <Button
        onClick={handleConnect}
        disabled={loading}
        variant={variant}
        className={`w-full ${className}`}
        data-testid="connect-tiktok-btn"
      >
        {loading ? (
          <>
            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            Connexion...
          </>
        ) : (
          <>
            <TikTokIcon className="w-4 h-4 mr-2" />
            Connecter TikTok
          </>
        )}
      </Button>
      
      {error && (
        <p className="text-sm text-red-500" data-testid="connect-tiktok-error">
          {error}
        </p>
      )}
    </div>
  );
}
